goog.provide("shadow.js.shim.module$$mui$material$Accordion");
goog.provide("module$shadow_js_shim_module$$mui$material$Accordion");
shadow.js.shim.module$$mui$material$Accordion = shadow.js.nativeProvides["@mui/material/Accordion"] = shadow$bridge("@mui/material/Accordion");
module$shadow_js_shim_module$$mui$material$Accordion.default = shadow.js.shim.module$$mui$material$Accordion;
